import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';

const ObservationsSectionTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    { key: 'date', content: t('Date') },

    { key: 'status', content: t('Status') },

    { key: 'observation', content: t('Observation') },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default ObservationsSectionTableHeader;
